const isChangeLang = false;
const headerTextFlag = false;

export const environment = {
	isChangeLang,
	production: true,
	headerTextFlag
};
